import styled from 'styled-components';
import { baseVariables } from '@marriott/mi-ui-library';

const { border, color } = baseVariables;

export const StyledPreApprovedImages = styled.div`
  .img-container {
    border: ${border.borderWidth10} ${border.borderStyleDefault} transparent;
    padding: 0;
  }
  .pre-approved-image {
    max-width: 100%;
    cursor: pointer;
    padding: 2px;
  }
  .selected-image {
    border-color: ${color.base10};
  }
`;
